type ZmileMarkProps = {
  accent?: string
  color?: string
  lineColor?: string
  showTerminus?: boolean
  size?: number
  strokeWidth?: number
  terminusRadius?: number
}

export const ZMILE_MARK_PATH = "M 28 34 L 116 34 L 28 110 L 116 110"

export function ZmileMark({
  accent = "var(--color-accent-bright)",
  color = "var(--color-ink-display)",
  lineColor,
  showTerminus = true,
  size = 120,
  strokeWidth = 16,
  terminusRadius = 10,
}: ZmileMarkProps) {
  return (
    <svg
      aria-hidden="true"
      className="zmile-mark"
      height={size}
      viewBox="0 0 144 144"
      width={size}
    >
      <path
        d={ZMILE_MARK_PATH}
        fill="none"
        stroke={lineColor ?? color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
      {showTerminus && (
        <circle cx="116" cy="110" fill={accent} r={terminusRadius} />
      )}
    </svg>
  )
}

type ZmileLockupProps = ZmileMarkProps & {
  gap?: number
}

export function ZmileLockup({
  gap = 22,
  size = 110,
  ...markProps
}: ZmileLockupProps) {
  return (
    <span className="zmile-lockup" style={{ gap }}>
      <ZmileMark {...markProps} size={size} />
      <span className="type-marketing-wordmark">Zmile</span>
    </span>
  )
}
